import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { FormsListCardView } from './FormsList/FormsListCardView/FormsListCardView';
import { FormsListView } from './FormsList/FormsListView/FormsListView';
import {
  createNewForm,
  getFormEditorControlData,
} from './store/slices/formEditorSlice';
import { getFormEditorFormThunk } from './store/thunks/formEditorThunks';
import { UiChangeViewButtons } from './UiChangeViewButtons/UiChangeViewButtons';
import Button from 'components/Button/Button';

export const FormEditorForms = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const controlData = useSelector(getFormEditorControlData);

  useEffect(() => {
    dispatch(getFormEditorFormThunk());
  }, []);

  const onCreateNewForm = () => {
    dispatch(createNewForm());
    history.push(`/form-editor/new`);
  };

  return (
    <>
      <div style={{ marginTop: '20px', marginLeft: '20px' }}>
        <h2>Lomakkeet:</h2>

        <div
          style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <Button variant="contained" color="primary" onClick={onCreateNewForm}>
            Luo uusi lomake
          </Button>
          <UiChangeViewButtons></UiChangeViewButtons>
        </div>
        {controlData.uiForShowingForms === 'list' ? (
          <FormsListView></FormsListView>
        ) : (
          <FormsListCardView></FormsListCardView>
        )}
      </div>
    </>
  );
};
